import axios from "axios";
import Swal from "sweetalert2";

export const downloadExcelFile = async (Pdfurl, excelname,message) => {
  let status = false;
  try {
    const response = await axios.get(Pdfurl, {
      responseType: "blob",
    });
    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = excelname;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    status = true;
    Swal.fire({
      title: message || "Excel downloaded successfully.",
      icon: "success",
      showCancelButton: false,
    });
  } catch (error) {
    status = false;
  }

  return status;
};
